import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { AssignmentsCalendar } from '../components/AssignmentsCalendar'
import {
  actionCreators,
  IAssignmentsCalendarState,
  selectDownloadUrl,
  selectEndTime,
  selectError,
  selectEvents,
  selectIsLoading,
  selectScope,
  selectStartTime,
} from '../modules/assignmentsCalendar'

export default connect(
  createStructuredSelector<
    ApplicationState,
    IAssignmentsCalendarState & ICurrentUserState
  >({
    downloadUrl: selectDownloadUrl(),
    endTime: selectEndTime(),
    error: selectError(),
    events: selectEvents(),
    isLoading: selectIsLoading(),
    scope: selectScope(),
    startTime: selectStartTime(),
    user: selectCurrentUser(),
  }),
  actionCreators,
)(AssignmentsCalendar)
